export default {
  eyebrow: 'Partner portal',
  title: 'Branding',
  description: 'The look of your white-label portal and login page.',
  page: {
    read_only_notice: 'Read-only. Click Edit to change any value.',
    editing_notice: 'Editing — changes are visible to your team and customers.',
  },
  branding: {
    scope_hint:
      "Applies to your white-label portal and login page — not your restaurants' storefronts, which are branded per restaurant.",
    upload: 'Upload logo',
    logo: {
      label: 'Logo',
      hint: 'Shown on your white-labelled surfaces.',
    },
    circle_logo: {
      label: 'Favicon / circle logo',
      hint: 'Square logo used as the favicon and avatar. Optional — can be removed.',
    },
    splash_image: {
      label: 'Login image',
      hint: 'Shown on your white-label login page. Recommended: at least 1200px wide. Optional — can be removed.',
    },
    footer_note: 'More branding options (secondary colours) coming later.',
  },
  form: {
    primary_color: {
      label: 'Primary brand colour',
      hint: 'Themes your partner portal and login.',
    },
    dashboard_subdomain: {
      label: 'Partner login slug',
      hint: 'Lowercase slug — identifies your brand in the team login link (?partner=…).',
      placeholder: 'partner-name',
    },
    login_url: {
      label: 'Team login link',
      hint: 'Share this link with your team — it opens the login page with your branding.',
    },
    file: {
      label: 'Image',
    },
  },
  login_url_warning: {
    title: 'Change your team login link?',
    description:
      'Your team login link will change to {{url}}. Share the new link from now on — the old one stops showing your brand.',
    description_no_url:
      'Your team login link will change. Share the new link from now on — the old one stops showing your brand.',
  },
  login_url_changed: {
    title: 'Team login link changed',
    description: 'Your team now logs in at {{url}}. Bookmark the new link and share it with your team.',
  },
  buttons: {
    edit: 'Edit',
    cancel: 'Cancel',
    save: 'Save',
  },
  toasts: {
    load_error: 'Could not load your branding.',
    failed_to_save_changes: 'Failed to save changes',
    changes_got_saved: 'Changes got saved',
    logo_uploaded: 'Logo uploaded',
    logo_upload_failed: 'Failed to upload the logo',
    logo_removed: 'Logo removed',
    logo_remove_failed: 'Failed to remove the logo',
    file_too_large: 'File is too large. Maximum size is {{max}} MB.',
    image_too_narrow: 'The login image must be at least {{min}}px wide.',
  },
};
